export const centerOfRect = ({x, y, width, height}) => ({
    x: x + width / 2,
    y: y + height / 2,
});
